import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.availableLanguages.length &&
    _setup.activeLanguage?.iso &&
    _setup.needTranslate
    ? _c(
        VListItem,
        {
          attrs: {
            "data-qa": `change-language-button-${_setup.activeLanguage.iso}`,
          },
          on: {
            click: function ($event) {
              return _setup.emit("click")
            },
          },
        },
        [
          _c(
            VListItemIcon,
            [
              _c(VImg, {
                attrs: {
                  width: "24",
                  height: "16",
                  contain: "",
                  alt: _setup.activeLanguage.iso,
                  src: _setup.activeLanguage.flag_image?.url,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            VListItemContent,
            [
              _c(
                VListItemTitle,
                { staticClass: "text-body-1 text--text" },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _setup.activeLanguage.translations?.[
                          `name_${_setup.activeLanguage.iso}`
                        ] || _setup.activeLanguage.name
                      ) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }